<template>
    <div id="customdevice">
        <HrrBreadcrumb PMname="信息管理" CMname="用户站点管理" C2Mname="媒体管理" C3Mname="设备管理" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form label-position="right" inline class="lightbox-from" label-width="100px">
                    <el-form-item label="媒体编号：">
                        <span>{{lightboxInfo.lightBoxCode}}</span>
                    </el-form-item>
                    <el-form-item label="媒体名称：">
                        <span>{{lightboxInfo.lightBoxName}}</span>
                    </el-form-item>
                    <el-form-item label="媒体描述：">
                        <span>{{lightboxInfo.lightBoxDesc}}</span>
                    </el-form-item>
                    <el-form-item label="媒体地址：">
                        <span>{{lightboxInfo.lightBoxAddress}}</span>
                    </el-form-item>
                    <el-form-item label="所属地铁站：">
                        <span>{{lightboxInfo.siteName}}</span>
                    </el-form-item>
                </el-form>
            </template>
        </HrrMainCardLayout>
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform" v-if="false">
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="名称" value="siteName"></el-option>
                                <el-option label="描述" value="siteDesc"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('SiteAddDevice')">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('SiteModifyDevice')">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick"v-if="isHadFun('SiteDelDevice')" >删除</el-button>
                    <el-button type="primary" icon="el-icon-finished" size="small" @click="sendCmdClick" v-if="isHadFun('SiteSendTempOrder')">批量发送指令</el-button>
                    <el-button type="info" icon="fa fa-undo" size="small" @click="returnForm">返回</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left" sortable >
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" fixed="left" sortable v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" width="160" >
                    </el-table-column>
                    <el-table-column prop="lastLight" label="亮度" width="100"  >
                    </el-table-column>
                    <el-table-column prop="lastDebugStatus" label="最后调试状态" width="120" v-if="isHadFun('debug')" >
                    </el-table-column>
                    <el-table-column prop="lastDeviceTime" label="最后设备时间" width="160" v-if="isHadFun('debug')" >
                    </el-table-column>
                    <el-table-column prop="lastWorkedTime" label="已工作时长" width="100" >
                    </el-table-column>
                    <el-table-column prop="lastPowerWaste" label="功耗" width="100" >
                    </el-table-column>
                    <el-table-column prop="LastIsError" label="异常" width="100" >
                    </el-table-column>
                    <el-table-column prop="deviceVersion" label="当前版本号" width="140" sortable>
                    </el-table-column>
                    <el-table-column prop="lastUpdateDate" label="最后更新时间" width="160" sortable>
                    </el-table-column>
                    <el-table-column prop="adId" label="当前广告ID" width="120">
                    </el-table-column>
                    <el-table-column prop="adTitle" label="当前广告名称" width="120">
                    </el-table-column>
                    <el-table-column label="广告更换是否正确" width="140">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isRight==0">错误</span>
                            <span v-if="scope.row.isRight==1">正确</span>
                            <span v-if="scope.row.isRight==2||typeof(scope.row.isRight)=='object'">未校验</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="160" sortable>
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="80">
                    </el-table-column>
                    <el-table-column label="状态" align="center" fixed="right" width="120">
                        <template slot-scope="scope">
                            <el-tag effect="dark" type="info" disable-transitions v-if="scope.row.status==0">未使用</el-tag>
                            <el-tag effect="dark" type="success" disable-transitions v-if="scope.row.status==1">使用</el-tag>
                            <el-tag effect="dark" type="warning" disable-transitions v-if="scope.row.status==2">维修</el-tag>
                            <el-tag effect="dark" type="danger" disable-transitions v-if="scope.row.status==3">损坏</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="false">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('SiteModifyDevice')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('SiteDelDevice')">删除</el-button>
                            <el-button @click.stop="RowSendcmd(scope.row)" type="text" size="small" v-if="isHadFun('SiteSendTempOrder')" >发送指令</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </HrrMainLayout>
        <!--弹窗-->
        <el-dialog :title="(this.isbatch?'批量':'单')+'指令'" v-model="dialogVisible" :visible.sync="dialogVisible" class="el-dialog-resume">
            <el-tabs v-model="tab" type="card" @tab-click="handleClick">
                <el-tab-pane label="灯光指令" name="lightcmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="80px" id="lightForm">
                                <el-form-item :label="'指令'+(index+1)+'：'" prop="time" v-for="(lorder,index) in lightform.list">
                                    运行时间：<el-select v-model="lorder.time" placeholder="小时" size="mini">
                                        <el-option v-for="item in timeData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    ：<el-select v-model="lorder.min" placeholder="分钟" size="mini">
                                        <el-option v-for="item in minData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    亮度(%)：<el-input-number v-model="lorder.percentage" :min="0" :max="100" label="亮度百分比" size="mini">
                                    </el-input-number>
                                    &nbsp;<el-button type="info" @click="delLightOrder(lorder)" size="mini" v-if="index!=0">删除指令</el-button>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="danger" @click="AddLightOrder()" :disabled="disabled" >添加指令</el-button>
                                    <el-button type="primary" @click="addCmd('light')">发送灯光指令</el-button>
                                    <el-button type="info" @click="addCmd('close')" round>关灯</el-button>
                                    <el-button type="danger" @click="addCmd('open')" round>开灯</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="自定义指令" name="mycmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="130px" :model="myform" ref="myform">
                                <el-form-item label="自定义指令：" prop="cmd">
                                    <el-input v-model="myform.cmd" type="textarea" :rows="4"></el-input>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="primary" @click="addCmd('my')">发送指令</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'site_info',
    data() {
        return {
            tab: "lightcmd",
            disabled: false,
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteDesc: "",
                siteName: "",
            },
            myform: {
                cmd: ""
            },
            lightform: {
                list: [{
                    time: "00",
                    min: "00",
                    percentage: 0
                }]
            },
            startform: {
                // min:"",
                number: "01"
            },
            cmdform: {
                MN: "",
                Content: ""
            },
            lightboxInfo: {},
            lightBoxId: "",
            tableData: [],
            timeData: [],
            minData: [],
            numberData: [],
            total: 0,
            loading: true,
            selectionRows: [],
            selectfield: "siteName",
            keyword: "",
            dialogVisible: false,
            isbatch: false
        }
    },
    methods: {
        onSubmit() {
            this.searchform.siteName = "";
            this.searchform.siteDesc = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.initData();
        },
        linestatus(row){
            if(row.isOnline==null){
                return "device-never";
            }
            if(row.isOnline==1){
                return "device-online";
            }
            if(row.isOnline==0){
                return "device-offline";
            }
        },
        returnForm() {
            this.$router.push({ path: '/site/customlightbox' + "/" + this.$store.state.siteInfo.siteId });
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/device/info/view/' + this.isFormLightbox + "/" + val.deviceId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/device/info/edit/' + this.isFormLightbox + "/" + val.deviceId });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.siteName + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.site.DelSite + "/" + val.siteId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        RowSendcmd(val) {
            this.dialogVisible = true;
            this.isbatch = false;
            this.cmdform.MN = val.deviceCode;
        },
        sendCmdClick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在发送", type: "warning" });
                return;
            }
            this.isbatch = true;
            this.dialogVisible = true;
        },
        Addclick() {
            this.$router.push({ path: '/device/info/add/' + this.isFormLightbox });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        pubclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }

        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/device/info/edit/' + this.isFormLightbox + "/" + this.selectionRows[0].deviceId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.site.DelSite + "/" + myrow.siteId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            //this.$hrraxios.get(this.$api.device.getdeviceList, {params:this.searchform})
            this.$hrraxios.get(this.$api.lightbox.lightboxDevice + "/" + this.lightBoxId)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            //this.$common.getplanlist(this,"planIdData");
            //this.$common.getFunListByMCode(this,"PlanOpen");
        },
        AddLightOrder() {
            if (this.lightform.list.length < 9) {
                this.lightform.list.push({ time: "00", min: "00", percentage: 0 });
            } else {
                this.$message({ message: "最多添加9条灯光指令", type: "warning" });
                this.disabled = true
            }

        },
        delLightOrder(item) {
            var index = this.lightform.list.indexOf(item)
            if (index !== -1) {
                this.disabled = false
                this.lightform.list.splice(index, 1);
            }
        },
        initTime(){
                for(let i=0;i<=23;i++){
                    this.timeData.push((i.toString().length==1)?"0"+i.toString():i.toString());
                }
                for(let i=0;i<=59;i++){
                    this.minData.push((i.toString().length==1)?"0"+i.toString():i.toString());
                }
                for(let i=1;i<=60;i++){
                    this.numberData.push((i.toString().length==1)?"0"+i.toString():i.toString());
                }
            },
        addCmd(type) {
            this.cmdform.Content = "";
            if (type == "my") {
                this.cmdform.Content = this.myform.cmd;
            }
            if (type == "light") {
                let LorderList = this.lightform.list;
                for (let i = 0; i < LorderList.length; i++) {
                    let p = LorderList[i].percentage.toString();
                    p = (p.length == 1) ? "00" + p : p;
                    p = (p.length == 2) ? "0" + p : p;
                    this.cmdform.Content += "00" + LorderList[i].time + LorderList[i].min + p + (i < (LorderList.length - 1) ? "," : "");
                }
            }
            if (type == "start") {
                // this.cmdform.Content="01"+this.startform.min.split(":")[1]+this.startform.number;
                this.cmdform.Content = "01" + this.startform.number;
            }
            if (type == "open") {
                this.cmdform.Content = "open"
            }
            if (type == "close") {
                this.cmdform.Content = "000000000"
            }
            var loading = this.$loading({
                lock: true,
                text: '提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var Vuethis = this;
            var apiUrl = this.$api.OrderTemp.api;
            if (this.isbatch) {
                var PostfunArr = [];
                this.selectionRows.forEach(myrow => {
                    this.cmdform.MN = myrow.deviceCode;
                    var postRe = this.$hrraxios.post(apiUrl, this.cmdform)
                    PostfunArr.push(postRe);
                });
                this.$axios.all(PostfunArr)
                    .then(this.$axios.spread(function() {
                        loading.close();
                        //console.log(arguments);
                        var isalldel = true;
                        for (var i = 0; i < arguments.length; i++) {
                            if (arguments[i].data.Success == false) {
                                isalldel = false;
                            }
                        }
                        if (isalldel == true) {
                            Vuethis.$message({ message: "全部发送成功！", type: "success" });
                            Vuethis.dialogVisible = false;
                            Vuethis.initData();
                        } else {
                            //有删除失败的未处理
                        }
                    }));
            } else {
                this.$hrraxios.post(apiUrl, this.cmdform)
                    .then(function(response) {
                        loading.close();
                        var data = response.data;
                        if (data.Success == true) {
                            Vuethis.$alert("指令提交成功！", {
                                callback: action => {
                                    Vuethis.dialogVisible = false;
                                }
                            });
                        } else {
                            Vuethis.$message({ message: data.Prompt, type: "error" });
                        }
                    }).catch(function(error) {
                        loading.close();
                        console.log(error);
                    })
            }

        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        next();
    },
    created() {
        this.$store.commit('getlightboxInfo');
        this.lightboxInfo = this.$store.state.lightboxInfo;
        this.$common.getFunListByMCode(this, "CustomSite", () => {
            if (this.$route.params.id) {
                this.lightBoxId = parseInt(this.$route.params.id);
            }
            this.initTime();
            this.initData();
            this.initParamsData();
        });
    }
}
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}

#customdevice .lightbox-from .el-form-item__label {
    font-size: 14px !important;
    font-weight: bold;
    color: #4a65fb;
}

#customdevice .lightbox-from .el-form-item__content {
    font-size: 14px !important;
}

#customdevice .lightbox-from .el-form-item {
    margin-bottom: 0;
}
</style>